(function (ws, $, globals) {
    'use strict';

    //Tooltip only for order-details, few things need to be removed
    //Tooltip with right arrow
    ws.views.quoteTableTooltipTop = Backbone.View.extend({

        className: 'comp-table-tooltip-top',

        events:  {
            'click .update-from-tooltip-top':'getValueFromTooltip'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.eventAgg = globals.eventAgg;
            this.eventAgg.on('quoteTableTooltipTop', this.setProps.bind(this));
            this.timeOut = null;
            this.tooltipIsActive = 0;
            this.render();
            this.obj = null;

        },

        /**i
         * Set Props
         * @param {Object} options
         */
        setProps: function (options) {
            this.options = options;
            this.update();
        },

        /**i
         * Render Tooltip
         */
        render: function () {
            $('body').append(this.$el);
        },

        getValueFromTooltip: function(e) {
            var val = $(e.currentTarget).val();
            if (this.options.isVrfHeader) {
                this.eventAgg.trigger('updateValue', this.options.pointerName, val);
            } else if (this.options.isOrderDetailsHeader) {
                this.eventAgg.trigger('updateOrderDetailsHeader', e, this.options.pointerName, val);
            } else {
                var fName = ('pricing' in this.options) ? 'getDataFromTooltip' : 'getVrfDataFromTooltip';
                this.eventAgg.trigger(fName, val, this.options.pointerName);
            }
        },

        /**
         * Update Tooltip
         */
        update: function () {
            if (isOrderEntrySite && this.options.pointerName) {
                this.obj = {name: this.options.pointerName,
                    radioNotRequired: false,
                    row: this.options.currentRow,
                    model: this.options.model};
            }

            switch ('html' in this.options) {
                case true:
                    this.$el.html(this.options.html);
                    break;

                default:
                    if (this.options.pointerName) {
                        this.$el.html(this.options.template(this.obj || {}));
                    } else {
                        this.$el.html(this.options.template(this.options.model || {}));
                    }
            }

            this.bindEvents();
            this.position();
        },

        bindEvents: function () {
            if (this.tooltipIsActive) {
                clearTimeout(this.timeOut);
                this.tooltipIsActive = 0;
            }

            $('.comp-table-tooltip-top').mouseleave(function() {
                $('.comp-table-tooltip-top').hide();
            });

            this.mouseout = function () {
                if (!this.tooltipIsActive) {
                    this.timeOut = setTimeout(() => {if ($('.comp-table-tooltip-top:hover').length === 0) {
                        this.$el.hide();
                    }}, 400);

                    this.tooltipIsActive = 1;
                }

                if ('onClose' in this.options) {
                    this.options.onClose();
                }

                this.options.follow.removeEventListener('mouseout', this.mouseout, false);
            }.bind(this);

            this.options.follow.addEventListener('mouseout', this.mouseout);
        },

        /**
         * Set Tooltip Position
         */
        position: function () {
            $('.comp-table-tooltip').addClass('top');
            var position = this.options.follow.getBoundingClientRect();
            var leftPosition = this.options.isPricingOption ? (position.left + this.options.follow.offsetWidth + 5) - 220 : (position.left + this.options.follow.offsetWidth + 5);
            this.$el.css({ top: position.top + (position.height) - 65, left: leftPosition - 174}).show();
        }

    });
})(westcon, jQuery, globals);
